import { useFlag } from '@/flags';
import { useSourceFreemium } from './use-source-freemium';

export function useFreemiumBoardLock() {
  const enabled = useFlag('source-freemium-board-lock');
  const isFreemium = useSourceFreemium();
  return enabled && isFreemium;
}
